import React from 'react'
import AgreementsPanel from "./AgreementsPanel";

function Index(
    {
        expanded
    }) {
    return (expanded && <AgreementsPanel/>)
}


export default Index;